import phoneFormat from '../format/phone-format';
import isEmpty from './is-empty';

export default function checkTel(tel = '') {
  if(isEmpty(tel)) return '휴대폰번호를 입력해주세요.';

  const t = phoneFormat(tel);

  if(!/^(01[0|1|6|7|8|9])[- ]?([0-9]{3,4})[- ]?([0-9]{4})$/.test(t)) {
    return '휴대폰번호 형식을 확인해주세요.';
  }

  return false;
}